import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  button: ({ disabled }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 45,
    padding: '0px 20px',
    borderRadius: 5,
    border: `1px solid ${theme.borderColor}`,
    outline: 'none',
    overflow: 'hidden',
    background: theme.white,
    color: disabled ? theme.midGrey : '#575d6b',
    '&:hover:not(:disabled)': {
      background: theme.superlightGrey,
    },
  }),
}))

const CancelButton = (props) => {
  const {
    label,
    customClass,
    disabled = false,
    type = 'button',
    className,
    dataQsId,
    ...otherProps
  } = props
  const classes = useStyles({ disabled })

  return (
    <button
      data-qs-id={dataQsId}
      type={type}
      className={clsx(classes.button, customClass, className)}
      disabled={disabled}
      {...otherProps}
    >
      {label}
    </button>
  )
}

CancelButton.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  customClass: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  dataQsId: PropTypes.string.isRequired,
}

export default CancelButton
